import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020netcom/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

export function getComment(page: number) {
  return http.get(`${baseUrl}comment-list-wap&page=${page}`);
}

export const postSave = (data: any) => {
  return http.post(`${baseUrl}comment-save`, qs.stringify(data));
};
